import { useSelector } from "react-redux"
import './index.css'

const SponsorsFooter = ()=>{
    const allPatternships = useSelector(state => state?.tournaments?.selectedTournament?.patrocinadores)
    console.log('allPatternships', allPatternships)
    if(allPatternships?.length <= 0) return <></>

    return(
        <div className="container-sponsors">
            {
                allPatternships?.map( (sponsor, i)=>(
                    <img className="sponsor-img" src={sponsor?.imgPatrocinador} />
                ))
            }

        </div>
    )
}

export default SponsorsFooter